/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

export const BaseCardFragment = gql`
  fragment BaseCardFragment on Card {
    __typename
    sys {
      id
    }
    appearance
    badge
    badgeBackgroundColor
    badgeTextColor
    customImage {
      url
      title
      description
      contentType
    }
    description
    jumpLink
    lifestyleImage {
      url
      title
      description
      contentType
    }
    primaryImage {
      url
      title
      description
      contentType
    }
    productId
    showColorOptions
    showSizeOptions
    title
  }
`;
